import { render, staticRenderFns } from "./ProjectForm.vue?vue&type=template&id=45b7b2bb&scoped=true"
import script from "./ProjectForm.vue?vue&type=script&lang=js"
export * from "./ProjectForm.vue?vue&type=script&lang=js"
import style0 from "./ProjectForm.vue?vue&type=style&index=0&id=45b7b2bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b7b2bb",
  null
  
)

export default component.exports